import adminRoutes from "./adminRoutes";

export default {
  rootPath: () => "/",
  termsOfServicePath: () => "/terms-of-service",
  termsOfSalePath: () => "/terms-of-sale",
  privacyPath: () => "/privacy",
  legalPath: () => "/legal",
  aboutUsPath: () => "/about-us",
  loginPath: () => "/login",
  logoutPath: () => "/logout",
  signUpPath: () => "/create/account",
  resetPasswordPath: () => "/password-reset",
  resetPasswordReturnPath: () => "/password-reset-return",
  loginHelpPath: () => "/login-help",

  myEcardsPath: () => "/account/ecards",
  myAccountPath: () => "/account/overview",
  changeNamePath: () => "/account/name",
  changeEmailPath: () => "/account/email",
  changePasswordPath: () => "/account/password",
  receiptsPath: () => "/account/receipts",
  receiptPath: (id) => `/account/receipt/${id}`,
  subscriptionDetailsPath: () => "/account/subscription-details",
  editRenewalPath: () => "/account/edit-renewal",
  updateCreditCardPath: () => "/account/update-creditcard",
  categoryPath: (slug) => `/browse/${slug}`,
  categoriesPath: () => "/browse",
  templateGroupPath: (slug) => `/view/template/${slug}`,
  contentfulPagePath: (slug) => `/videos/${slug}`,
  facePath: () => "/face",
  newCastPath: (slug) => `/create/cast/${slug}`,
  makeViewPath: (slug, id) => `/view/make/${slug}/${id}`,
  makePreviewPath: (slug, id) => `/view/make-preview/${slug}/${id}`,
  paymentPath: () => "/create/purchase/payment",
  purchaseConfirmationPath: () => "/create/purchase/confirmation",
  paypalConfirmationPath: () => "/paypal/return",
  videosPath: () => "/videos",
  activityPath: () => "/activity",
  peoplePath: () => "/account/people",
  searchPath: () => "/search",
  page404Path: () => "/not-found",
  unauthorizedPath: () => "/unauthorized",
  ...adminRoutes,
};
